export const APPEND_TO = {
    window: 'window',
    viewport: 'viewport',
    scrollParent: 'scrollParent',
    parent: 'parent',
};
//# sourceMappingURL=PopoverNext.constants.js.map